import { Link } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'

import { tr } from 'mmfintech-commons'

import SelectMethod from '@components/SelectMethod'
import { ErrorDisplay, Input } from 'mmfintech-portal-commons'

import type { CountryChoice, PaymentOptionResponse } from 'mmfintech-checkout-commons/types'

type SelectMethodStepProps = {
  countryCode: string
  setCountryCode: (code: string) => void
  paymentMethod: string
  setPaymentMethod: (method: string) => void
  paymentOptions: PaymentOptionResponse[]
  paymentOptionsFetching: boolean
  onContinue: () => void
  showCancel: boolean
  onCancel: () => void
  disabled?: boolean
}

export const SelectMethodStep = (props: SelectMethodStepProps) => {
  const {
    countryCode,
    setCountryCode,
    paymentMethod,
    setPaymentMethod,
    paymentOptions,
    paymentOptionsFetching,
    onContinue,
    showCancel,
    onCancel,
    disabled
  } = props

  const { checkoutCountries, checkoutPayError, session, sessionError } = useSelector(
    ({ checkout: { checkoutCountries, checkoutPayError, session, sessionError } }) => ({
      checkoutCountries,
      checkoutPayError,
      session,
      sessionError
    }),
    shallowEqual
  )

  const isCountrySelectionVisible = () =>
    Array.isArray(checkoutCountries) && checkoutCountries.length > 1 && !session?.country

  const handleCountryChanged = (_name: string, value: string) => setCountryCode(value)

  return (
    <>
      <ErrorDisplay error={[sessionError, checkoutPayError]} />

      {isCountrySelectionVisible() ? (
        <div className='mb-4'>
          <Input
            type='select'
            name='countryCode'
            data-test='country-select'
            label={tr('CHECKOUT.PAYMENT.COUNTRY_PLACEHOLDER', 'Select country')}
            options={checkoutCountries?.map((v: CountryChoice) => ({
              value: v.countryCode,
              label: v.name
            }))}
            value={countryCode}
            onChange={handleCountryChanged}
            hideErrorLine
          />
        </div>
      ) : null}

      <SelectMethod
        paymentOptions={paymentOptions}
        method={paymentMethod}
        setMethod={setPaymentMethod}
        onContinue={onContinue}
        disabled={disabled}
        errorVisible={countryCode && !paymentOptionsFetching}
      />

      {showCancel ? (
        <div className='cancel-button-container'>
          <Link to='#' onClick={onCancel} data-test='cancel-button'>
            {tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
          </Link>
        </div>
      ) : null}
    </>
  )
}
